import React from 'react';
import { Card } from 'react-bootstrap';
import TemplateDetailsGmap from './TemplateDetailsGmap';
import PropTypes from 'prop-types';
import Flex from 'components/common/Flex';
import moment from 'moment';

const TemplateDetailContent = ({ template }) => {
  return (
    <Card>
      <Card.Body>
        {template?.customerName && (
          <>
            <Flex>
              <h5 className="fs-9 mb-3">Customer Name</h5>
              {template?.customerVisibility && <p className="text-danger">*</p>}
            </Flex>
            <p>{template?.customerName}</p>
          </>
        )}
        <h5 className="fs-9 mb-3">License Type</h5>
        <Flex>
          {template?.licenseType?.map((item, index) => {
            return (
              <p key={index} className={'me-2'}>
                {item}
              </p>
            );
          })}
        </Flex>
        {template?.specialty && (
          <>
            <Flex>
              <h5 className="fs-9 mb-3">Specialty</h5>
              {template?.specialtyRequired && <p className="text-danger">*</p>}
            </Flex>
            <p>{template?.specialty}</p>
          </>
        )}
        {template?.certification?.length !== 0 && (
          <>
            <Flex>
              <h5 className="fs-9 mb-3">Certification</h5>
              {template?.certificationRequired && (
                <p className="text-danger">*</p>
              )}
            </Flex>
            <Flex>
              {template?.certification?.map((item, index) => {
                return (
                  <p key={index} className="me-2">
                    {item}
                  </p>
                );
              })}
            </Flex>
          </>
        )}
        {template?.yearOfExperience && (
          <>
            <Flex>
              <h5 className="fs-9 mb-3">Experience Level</h5>
              {template?.experienceRequired && <p className="text-danger">*</p>}
            </Flex>
            <p>{template?.yearOfExperience}</p>
          </>
        )}
        {template?.EMRorEHRExperience?.length !== 0 && (
          <>
            <Flex>
              <h5 className="fs-9 mb-3">EMR or EHR Experience</h5>
              {template?.emrehrRequired && <p className="text-danger">*</p>}
            </Flex>
            <Flex>
              {template?.EMRorEHRExperience?.map((item, index) => {
                return (
                  <p key={index} className="me-2">
                    {item}
                  </p>
                );
              })}
            </Flex>
          </>
        )}
        <>
          <h5 className="fs-9 mb-3">{template?.jobType} Times</h5>
          <p>{template?.jobTiming}</p>
        </>
        <>
          <h5 className="fs-9 mb-3">Break</h5>
          <p>{template?.break === 'NA' ? 'No Break' : template?.break}</p>
        </>
        <>
          <h5 className="fs-9 mb-3">Current Rate</h5>
          <p>$ {template?.baseRate} / hr</p>
        </>
        {template?.enableBid && template?.maxBidAmount && (
          <>
            <h5 className="fs-9 mb-3">Max Bid Amount</h5>
            <p>$ {template?.maxBidAmount} / hr</p>
          </>
        )}
        {template?.notes !== '' && (
          <>
            <h5 className="fs-9 mb-3">Notes</h5>
            <p>{template?.notes}</p>
          </>
        )}
        <>
          <h5 className="fs-9 mb-3">Last Updated</h5>
          <p>{moment(template?._lastChangedAt).format('MM-DD-YYYY h:mm a')}</p>
        </>

        {/* <h5 className="fs-9 mt-5 mb-2 ">Tags</h5>
        <Link
          to="#!"
          className="badge border link-secondary text-decoration-none me-1"
        >
          Things To Do In Brooklyn, NY
        </Link>
        <Link
          to="#!"
          className="badge border link-secondary text-decoration-none me-1"
        >
          Party
        </Link>
        <Link
          to="#!"
          className="badge border link-secondary text-decoration-none me-1"
        >
          Music
        </Link> */}
        <TemplateDetailsGmap template={template} />
      </Card.Body>
    </Card>
  );
};

TemplateDetailContent.propTypes = {
  template: PropTypes.any
};

export default TemplateDetailContent;
